import { NodeViewSettingsPanel } from '@/components/common/node-view-settings-panel';
import { CommonNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { type ReactNodeViewProps } from '@tiptap/react';
import { memo } from 'react';

const ZyYoutubeVideoNodeView: React.FC<ReactNodeViewProps> = ({ node, updateAttributes, selected, decorations }) => {
    const { caption, link } = node.attrs;

    const handleCaptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateAttributes({ caption: e.target.value });
    };

    const isYoutubeLink = (url: string) => {
        return url.includes('youtube.com') || url.includes('youtu.be');
    };

    const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let newURL = e.target.value;
        if (isYoutubeLink(newURL)) {
            // Turn a watch link into an embed link
            newURL = newURL.replace('watch?v=', 'embed/');
        }
        updateAttributes({ link: newURL });
    };

    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label="zyYoutubeVideo"
            selected={selected}
            settingsPanel={
                <NodeViewSettingsPanel
                    fields={[
                        {
                            label: 'Caption',
                            type: 'text',
                            value: caption ?? '',
                            onChange: handleCaptionChange,
                            placeholder: 'Caption...',
                            searchAttr: 'caption',
                        },
                        {
                            label: 'Link',
                            type: 'text',
                            value: link ?? '',
                            onChange: handleUrlChange,
                            placeholder: 'YouTube URL...',
                        },
                    ]}
                />
            }
            contentClassName="px-4 pb-4"
        >
            {link && isYoutubeLink(link) ? (
                <div
                    className="aspect-w-16 aspect-h-9"
                    contentEditable={false}
                >
                    <iframe
                        src={link}
                        title={caption || 'YouTube Video'}
                        className="w-full"
                        height="500px"
                    />
                </div>
            ) : null}
        </CommonNodeViewWrapper>
    );
};

export default memo(ZyYoutubeVideoNodeView);
